'use client';

import ErrorPage from '@components/ErrorPage';
import { useEffect } from 'react';

export type RouteErrorProps = {
  error: Error & { digest?: string };
  /** Re-renders the segment without refetching. */
  reset: () => void;
  /** Refreshes the route, then re-renders (Next 16.3). */
  retry: () => void;
};

/**
 * Builds a route `error.tsx` boundary: logs the error with `logPrefix` and
 * shows the shared error page. Its Try again button calls Next's `reset` by
 * default, or `retry` (refetch, then re-render) when `recover` says so.
 */
export function createRouteError(
  logPrefix: string,
  { recover = 'reset' }: { recover?: 'reset' | 'retry' } = {}
) {
  function RouteError({ error, reset, retry }: RouteErrorProps) {
    useEffect(() => {
      console.error(logPrefix, error);
    }, [error]);

    return <ErrorPage reset={recover === 'retry' ? retry : reset} />;
  }
  return RouteError;
}
